import { useNavigate } from "react-router-dom";
import { useDining } from "../context/DiningContext";
import { useEffect, useState } from "react";
import { restaurantService } from "../services";
import defaultImage from "../assets/images/cuisines/default.jpeg";

// Aligned with mobile App/Screens/Home/DinningHome.tsx + DINNING_TYPE_DATA
const DINING_TYPES = [
  { id: "1", title: "Family Dining", emoji: "👨‍👩‍👧‍👦" },
  { id: "2", title: "Romantic Dining", emoji: "💑" },
  { id: "3", title: "Friends & Hangouts", emoji: "🎉" },
  { id: "4", title: "Corporate Dining", emoji: "💼" },
  { id: "5", title: "Birthday Celebration", emoji: "🎂" },
  { id: "6", title: "Kids Friendly", emoji: "🧒" },
];

const DiningHome = () => {
  const navigate = useNavigate();
  const { toggleDining } = useDining();
  const [restaurants, setRestaurants] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchRestaurants = async () => {
      try {
        setLoading(true);
        const response: any = await restaurantService.getUserRestaurants({
          page: 1,
          limit: 8,
        });
        setRestaurants(response.data || []);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };
    fetchRestaurants();
  }, []);

  return (
    <div className="max-w-[1400px] mx-auto p-2 md:p-5 bg-white dark:bg-gray-900 min-h-screen transition-colors duration-300">
      <div className="flex gap-3 items-center my-3 md:my-5">
        <div className="flex-1 flex items-center gap-2 px-4 h-12 rounded-[12px] bg-[#F5F5F5] dark:bg-gray-800 border dark:border-gray-700">
          <span className="text-[#7402A7]">⌕</span>
          <input
            placeholder="Restaurant name or dish..."
            className="flex-1 bg-transparent outline-none text-sm dark:text-white"
            onFocus={() => navigate("/result")}
            readOnly
          />
        </div>
        <button
          onClick={toggleDining}
          className="flex items-center gap-2 h-12 px-3 rounded-l-[12px] bg-[#7402A7] text-white font-urbanist text-sm font-semibold whitespace-nowrap"
        >
          <span className="leading-tight text-left">
            Order
            <br />
            Food
          </span>
          <span className="text-2xl">🍽️</span>
        </button>
      </div>

      <div className="h-[159px] rounded-[20px] bg-[#D3C9F6] dark:bg-purple-900/40 mb-6 flex items-center justify-center">
        <p className="text-[#7402A7] dark:text-purple-300 font-urbanist text-xl font-semibold">
          Discover dining experiences near you
        </p>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 md:gap-4 mb-8">
        {DINING_TYPES.map((item) => (
          <div
            key={item.id}
            className="rounded-[16px] border dark:border-gray-700 bg-white dark:bg-gray-800 p-4 flex flex-col items-center text-center cursor-pointer hover:shadow-md transition-shadow"
            onClick={() => navigate("/dining/restaurants")}
          >
            <span className="text-3xl mb-2">{item.emoji}</span>
            <p className="text-[#050505] dark:text-white font-urbanist text-sm font-medium">
              {item.title}
            </p>
          </div>
        ))}
      </div>

      <h2 className="text-[#050505] dark:text-white font-urbanist text-[20px] font-semibold mb-4">
        Nearby Restaurants
      </h2>

      {loading ? (
        <p className="text-gray-500 dark:text-gray-400">Loading...</p>
      ) : (
        <div className="flex gap-4 overflow-x-auto pb-4 scrollbar-hide">
          {restaurants.map((r) => (
            <div
              key={r._id}
              onClick={() => navigate(`/dining/restaurants/${r._id}`)}
              className="min-w-[260px] max-w-[280px] rounded-[16px] border dark:border-gray-700 overflow-hidden cursor-pointer bg-white dark:bg-gray-800 hover:shadow-md transition-shadow"
            >
              <img
                src={r.kitchenPhotos?.[0] || defaultImage}
                alt={r.businessName}
                className="w-full h-36 object-cover"
              />
              <div className="p-3">
                <h3 className="text-[#050505] dark:text-white font-semibold truncate">
                  {r.businessName}
                </h3>
                <p className="text-[#6A6A6A] dark:text-gray-400 text-xs mt-1 truncate">
                  {r.location?.city || r.location?.address || ""}
                </p>
                <div className="flex gap-2 mt-2">
                  <button
                    className="flex-1 py-2 text-xs rounded-full bg-[#7402A7] text-white"
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate(`/dining/restaurants/${r._id}`);
                    }}
                  >
                    Book Table
                  </button>
                  <button
                    className="flex-1 py-2 text-xs rounded-full border border-[#7402A7] text-[#7402A7]"
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate(`/dining/pay-bill/${r._id}`);
                    }}
                  >
                    Pay Bill
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default DiningHome;
